module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bq-04ca6698f051e72cf774e2d036039e3b.svg";